import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers/smooth-scroll-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/transitions.css");
;
import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/components/Background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirebaseProvider"] */ "/vercel/path0/components/firebase-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "/vercel/path0/components/loading-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransitionProvider"] */ "/vercel/path0/components/page-transition-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/lib/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Assistant-VariableFont_wght.ttf\",\"variable\":\"--font-assistant\"}],\"variableName\":\"assistant\"}");
